"use client";

import { Suspense as RouteSuspense } from 'react';
import { PageLoading as RouteLoading } from '@/app/Components/LoadingBubbles';
import { useSearchParams } from 'next/navigation';
import { auditFixtureState } from '@/app/lib/routeStateContract';
import { SirsAuditFixture } from './auditFixture';
import SIRSPageClient from './SIRSPageClient';

function SIRSRoute() {
  const state = auditFixtureState(useSearchParams().get('auditFixture'));
  return state === 'populated' || state === 'empty' || state === 'stale-cache' || state === 'hard-failure'
    ? <SirsAuditFixture state={state} />
    : <SIRSPageClient />;
}

// Query-dependent interactive content owns its loading boundary.
export default function RoutePage() { return <RouteSuspense fallback={<RouteLoading title="Preparing your workspace" />}><SIRSRoute /></RouteSuspense>; }
